import React from 'react';
import ListItem from '../item-list/list-item';

import * as S from './styles';

const ListItemDnd = props => {
  const {
    highlighted,
    hovered,
    connectDragSource,
    connectDropTarget,
    connectDragPreview,
    deleted,
    item,
    handle,
  } = props;

  if (props.handle) {
    return (
      <S.DragItem
        highlighted={highlighted}
        hovered={hovered}
        deleting={deleted[item.id]}
        ref={instance => connectDragPreview(instance)}
      >
        {connectDragSource(connectDropTarget(handle))}
        <ListItem draggable {...props} hasDragHandle={Boolean(handle)} />
      </S.DragItem>
    );
  }

  return connectDropTarget(
    connectDragSource(
      <div>
        <S.DragItem
          highlighted={highlighted}
          hovered={hovered}
          deleting={Boolean(deleted[item.id])}
          ref={instance => connectDragPreview(instance)}
          key={item.id}
        >
          <ListItem draggable {...props} />
        </S.DragItem>
      </div>
    )
  );
};

ListItemDnd.defaultProps = {
  handle: null,
};

export default ListItemDnd;
